<mat-card class="metabase-card" [style.height]="currentFrameHeight">
  @if (showSpinner) {
    <mat-spinner color='primary' diameter="80" strokeWidth="4"></mat-spinner>
  }
  @if (url) {
    <iframe #iframeId (load)="loadSuccess()" [src]="url | safe: 'resourceUrl'" allowtransparency
      [attr.id]="'metabase-iframe-' + (organizationId ?? 'default')"
      data-hj-allow-iframe frameborder="0" scrolling="no"
      [style.height]="currentFrameHeight" style="background: #FFFFFF;">
    </iframe>
  }
</mat-card>
